import * as React from 'react'

import { Shadow, Wrapper } from './HeaderShadow.styles'

export const HeaderShadow: React.SFC = () => (
  <Wrapper>
    <Shadow />
  </Wrapper>
)

export default HeaderShadow
